import { create } from 'zustand';
import { debounce } from 'lodash';

type CreateRedditReportStore = {
	reportActionsOpenId?: string;
	setReportActionsOpenId: (reportId?: string) => void;
};

const useReportActionsOpen = create<CreateRedditReportStore>(((set) => ({
	reportActionsOpenId:    undefined,
	setReportActionsOpenId: debounce((reportId?: string) => set({ reportActionsOpenId: reportId }), 100),
})));

export default useReportActionsOpen;
